import axiosClient from '../../../config/axios-client'

const MineralService = {
  getMinerals() {
    return axiosClient.get(`/dashboard/services/minerals`)
  },
}

export default MineralService
